import React from 'react'
import classNames from 'classnames'
import { Row } from '@/components/layout/layout'
import ImportFinish from '@/assets/images/import-finish.svg'

import './import-layout.scss'

export interface ImportStep {
    title: string
}

interface ImportTipsProps {
    tips: React.ReactNode[]
    className?: string
}

interface ImportStepBarProps {
    steps: ImportStep[]
    current: number
    className?: string
}

export const ImportTips: React.FC<ImportTipsProps> = props => (
    <div className={classNames('import-tips', props.className)}>
        {props.tips.map((tip, index) => (
            <Row className="import-tips__row" key={index}>
                <div className="import-tips__index">{index + 1}.</div>
                <div className="import-tips__content">{tip}</div>
            </Row>
        ))}
    </div>
)

export const ImportStepBar: React.FC<ImportStepBarProps> = props => (
    <Row className={classNames('import-step-bar', props.className)}>
        {props.steps.map((step, index) => (
            <div
                className={classNames('import-step-bar__item', {
                    active: props.current === index,
                    complete: props.current > index,
                    unactive: props.current < index,
                })}
                key={step.title}
            >
                {props.current > index ? (
                    <img className="import-step-bar__finish" src={ImportFinish} alt="" />
                ) : (
                    <div className="circle" />
                )}
                <div className="txt">{step.title}</div>
                {index < props.steps.length - 1 ? <div className="import-step-bar__line" /> : null}
            </div>
        ))}
    </Row>
)
